// Minimal observable application state (session, organization, membership, permissions).

const state = {
  user: null,
  profile: null,
  memberships: [],
  membership: null,      // active membership row from rpc my_memberships()
  permissions: null,     // PermissionSet from permissions/permissions.js
  aal: 'aal1',
  mfaEnrollmentRequired: false,
  unreadCount: 0,
};

const listeners = new Set();

export const getState = () => state;

export function setState(patch) {
  Object.assign(state, patch);
  listeners.forEach((fn) => {
    try { fn(state, patch); } catch (e) { console.error(e); }
  });
}

export function subscribe(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export const currentOrgId = () => state.membership?.org_id ?? null;
